import { useCallback, useEffect, useState } from "react";
import { MusicNFT } from "../components/ExploreBase/types";
import {
  FractionalTransaction,
  QueryTransactionsRequest,
  QueryTransactionsResponse,
} from "../proto/api_pb";
import * as grpcWeb from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";

type ReturnType = {
  musicNFTs: MusicNFT[];
  isTransactionsLoading: boolean;
};
export const useQueryTransactions = (): ReturnType => {
  const [musicNFTs, setMusicNFTs] = useState<Array<MusicNFT>>([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleQueryTransactions = useCallback(
    async (err: grpcWeb.RpcError, response: QueryTransactionsResponse) => {
      try {
        if (err) {
          console.log("Error while fetching transactions: " + err.message);
          setIsLoading(false);
        } else {
          const transactions: FractionalTransaction[] = response
            .getFractionalTransactionList()
            .filter((t) => t.getTitle());
          const musicNfts = [];
          for (const transaction of transactions) {
            const title = transaction.getTitle();
            const artist = transaction.getArtist();
            const description = transaction.getDescription();
            const image = transaction.getImageUrl();
            const song = transaction.getSongUrl();
            const genres = transaction.getGenresList();
            const timestamp = transaction.getTimestamp();
            const contributors = transaction.getFractionalTransactionPartList();
            const ownerId = transaction.getOwnerId();
            const id = Number(transaction.getTokenId());
            const price = transaction.getInitialPrice();
            const txnId = transaction.getOmmuseTxnId();
            const state = transaction.getState();
            musicNfts.push({
              txnId,
              id,
              title,
              artist,
              description,
              image,
              song,
              price,
              genres,
              timestamp,
              contributors,
              ownerId,
              state,
            });
          }
          musicNfts.sort((a, b) => (a?.price ?? 0) - (b?.price ?? 0));
          setMusicNFTs(musicNfts);
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    },
    []
  );

  const fetchTransactions = useCallback(async () => {
    try {
      setIsLoading(true);
      const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
      const request = new QueryTransactionsRequest();
      const metadata = {
        "Access-Control-Allow-Origin": "*",
      };
      ommuseClient.queryTransactions(
        request,
        metadata,
        handleQueryTransactions
      );
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  }, [handleQueryTransactions]);

  useEffect(() => {
    fetchTransactions();
  }, [fetchTransactions]);

  return { musicNFTs, isTransactionsLoading: isLoading };
};
